<div class="app mat-typography">
  <ngx-loading-bar color="#009688"></ngx-loading-bar>
  <app-header *ngIf="showHeader"></app-header>
  <router-outlet></router-outlet>
</div>
